import React from "react";
import Chart from "react-apexcharts";
import Card from "../../../components/page/Card";
import CommonsHelper from "../../../helpers/CommonsHelper";
import PropTypes from "prop-types";

function FaturamentoGrafico({ tabelaDados }) {
  const isMobile = CommonsHelper.isMobile();

  const options = React.useMemo(
    () => ({
      options: {
        chart: {
          toolbar: { show: false },
          zoom: { enabled: true },
        },
        legend: {
          position: "top",
          fontSize: "14px",
        },
        plotOptions: {
          bar: {
            horizontal: isMobile ? true : false,
            columnWidth: isMobile ? null : "45%",
            borderRadius: 2,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: isMobile ? 8 : 2,
          colors: ["transparent"],
        },
        colors: ["#50a5f1", "#556ee6", "#34c38f"],
        fill: {
          opacity: 1,
        },
        grid: {
          borderColor: "#f1f1f1",
        },
        xaxis: isMobile
          ? {
              categories: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez",
              ],
              title: {
                text: "R$ (Reais)",
                style: {
                  fontWeight: "500",
                },
              },
              labels: {
                formatter: function (value) {
                  return value.toFixed(2);
                },
              },
            }
          : {
              categories: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez",
              ],
            },
        yaxis: isMobile
          ? {
              categories: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez",
              ],
            }
          : {
              title: {
                text: "R$ (Reais)",
                style: {
                  fontWeight: "500",
                },
              },
              labels: {
                formatter: function (value) {
                  return value.toFixed(2);
                },
              },
            },
      },
      series: tabelaDados,
    }),
    [isMobile, tabelaDados]
  );

  return (
    <Card>
      <div className="row">
        <div className="mixed-chart">
          <Chart
            height={isMobile ? 840 : 420}
            options={options.options}
            series={options.series}
            type="bar"
          />
        </div>
      </div>
    </Card>
  );
}

FaturamentoGrafico.propTypes = {
  tabelaDados: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FaturamentoGrafico;
